/**
 * Provides a `Field`-based interface for filtering data for a given field.
 *
 * ## Fields
 * Name | Description
 * --- | ---
 * field | The `Field` associated with the control.
 *
 * ## Events
 * Name | Arguments | Description
 * --- | --- | ---
 * value | The new filter value | Fired whenever the filter value changes.
 * @module app/views/FilterView
 */
import Backbone from "backbone";
import _ from "underscore";
import $ from "jquery";
var FilterView = Backbone.View.extend({
  className: "filter",

  /**
   * Initializes the control.
   * @param  {object} options The options hash.
   * @param {Field} options.field The field to associate with this control.
   */
  initialize: function (options) {
    this.options = _.defaults({}, options);

    this.field = this.options.field;
    this._value = "";
  },

  events: {
    "change .filter-value": "_updateValue",
    "keyup .filter-value": "_updateValue",
  },

  render: function () {
    if (this.field) {
      var filterable = this.field.attributes.filterable;
      var attrs = this.field.attributes;
      var filter = false;

      if (filterable) {
        if (attrs.values) {
          filter = $('<select class="filter-value form-control"></select>');
          filter.append('<option value="">No ' + attrs.label + "</option>");
          _.each(attrs.values, function (value) {
            filter.append(
              '<option value="' + value.value + '">' + value.text + "</option>"
            );
          });
          filter = filter[0].outerHTML;
        } else {
          filter =
            '<input type="text" class="filter-value form-control" placeholder="' +
            attrs.label +
            '"/>';
        }

        this.$el.html(filter);
        this.delegateEvents();
      }
    }
  },

  _updateValue: function (evt) {
    var originalValue = this._value;

    this._value = $(evt.target).val();

    if (this._value != originalValue) {
      this.trigger("value", this._value);
    }
  },

  /**
   * Sets the filter value.
   * @param {string|Function} val The filter value *or* a function which, given a model, returns `false` if the model should be filtered out of a collection.
   */
  setValue: function (val) {
    this._value = val;

    if (_.isFunction(this._value)) {
      this.$el.hide();
    } else {
      this.$el.show();
      this.$(".filter-value").val(this._value);
    }

    this.trigger("value", this._value);
  },

  /**
   * Gets the filter value.
   * @return {string|Function} The filter value *or* a function which, given a model, returns `false` if the model should be filtered out of a collection.
   */
  getValue: function () {
    return this._value;
  },

  /**
   * Resets or clears the filter value.
   */
  resetValue: function () {
    this.$(".filter-value").val("").change();
  },
});

export default FilterView;



//////////////////
// WEBPACK FOOTER
// ./public/js/core/views/FilterView.js
// module id = 858
// module chunks = 1